import React from "react";
import cs from "classnames"

export type ApplicationLayoutProps = {
    className?: string;
    children: React.ReactNode;
}

const ApplicationLayout: React.FC<ApplicationLayoutProps> = ({className, children}) => {
  return <div className={cs(
    "h-full flex flex-col lg:flex-row",
    className
  )}>
    {children}
  </div>
}

export type ApplicationLayoutItemProps = {
    className?: string
    children: React.ReactNode;

}
export const ApplicationColumn: React.FC<ApplicationLayoutItemProps> = ({children, className}) => {
  return <div className={cs("h-fit", className)}>{children}</div>
}
export default ApplicationLayout;